// @flow

import React, { type Node } from 'react';
import { GlobalStyle } from './global-style';
import { Logo } from './logo';
import { LostInSpaceScene } from './lost-in-space-scene';
import { Content, Footer, Main, Message, Title, Wrapper } from './layout';
import { useEventBusPublisher } from '@tectonics/public-event-bus';
import { translate } from '@tectonics/translate';
import intl from 'react-intl-universal';
import * as englishLocalization from '@tectonics/translate/locales/en/volcanes';

type Props = {
  error: Error,
  localTenancy?: string,
};

export function FatalErrorPage({ error }: Props): Node {
  useEventBusPublisher('fatalError:dispatch', error);
  const { currentLocale } = intl.getInitOptions();
  const hasCurrentLocale = currentLocale !== null;

  const title = hasCurrentLocale
    ? translate('volcanes.fatalErrorTitle')
    : englishLocalization.fatalErrorTitle;

  const message = hasCurrentLocale
    ? translate('volcanes.fatalErrorMessage')
    : englishLocalization.fatalErrorMessage;

  const footer = hasCurrentLocale
    ? translate('volcanes.fatalErrorFooter')
    : englishLocalization.fatalErrorFooter;

  return (
    <>
      <GlobalStyle />
      <Wrapper>
        <Main>
          <LostInSpaceScene />
          <Content>
            <Title>{title}</Title>
            <Message>{message}</Message>
          </Content>
        </Main>
        <Footer>
          {footer} <Logo/>
        </Footer>
      </Wrapper>
    </>
  );
}
